import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import ButtonGroup from "../../components/shared/ButtonGroup";
import CoreStockTable from "../../components/core/CoreStockTable";
import CoreOrdersTable from "../../components/core/CoreOrdersTable";
import RsCoreImage from "../../components/core/RsCoreImage";
import FloatingCallToAction from "../../components/shared/FloatingCallToAction";
import { TruckIcon } from "@heroicons/react/24/outline";
import openInNewTab from "../../utils/openInNewTab";

export default function Core() {
  const { t } = useTranslation("stock");
  const { setInfo } = usePageNameContext();

  const [tab, setTab] = useState<"stock" | "orders">("stock");

  const options = useMemo(() => [
    { id: "stock", label: t("Stock"), value: "stock" },
    { id: "orders", label: t("Purchase Orders"), value: "orders" },
  ], [t]);

  const selectedIndex = tab === "stock" ? 0 : 1;

  useEffect(() => {
    setInfo({
      name: "RS Core",
      desc: t("View and manage all stock going to Core"),
    });
  }, []);

  return (
    <>
      <div className="flex items-center justify-between mb-4 mt-4">
        <ButtonGroup
          options={options}
          selectedIndex={selectedIndex}
          onChange={(id) => setTab(id as "stock" | "orders")}
        />

        <RsCoreImage className="!h-10" />
      </div>

      {tab === "stock" ? <CoreStockTable /> : <CoreOrdersTable />}

      <FloatingCallToAction
        label={t("Order Collection")}
        Icon={TruckIcon}
        onClick={() => openInNewTab(`https://rsautocoresystem.co.uk/purchase/index.php`)}
        colorClassName="bg-[#69141E] hover:!bg-[#4a0f14] focus:ring-[#69141E]"
        shouldEnterAnimate={true}
      />
    </>
  );
}
